import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { NAVIGATION_MODAL_ZINDEX } from '@telialt/common-constants/src/modal';
import HtmlContent from '@telialt/common-html-content/src';

import { NETFLIX_SELECTION_MODAL_TEST_ID } from './test-ids';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    description?: string;
    standardButtonLabel?: string;
    premiumButtonLabel?: string;
    onStandardClick: () => void;
    onPremiumClick: () => void;
};

export const NetflixSelectionModal: FC<Props> = ({
    isOpen,
    onClose,
    title: defaultTitle,
    description: defaultDescription,
    standardButtonLabel: defaultStandardButtonLabel,
    premiumButtonLabel: defaultPremiumButtonLabel,
    onStandardClick,
    onPremiumClick,
}) => {
    const { t } = useTranslations();

    const title = defaultTitle || t['common.netflix_selection_modal.title'];
    const description = defaultDescription || t['common.netflix_selection_modal.description'];
    const standardButtonLabel = defaultStandardButtonLabel || t['common.netflix_selection_modal.standard_button_label'];
    const premiumButtonLabel = defaultPremiumButtonLabel || t['common.netflix_selection_modal.premium_button_label'];

    const actions = (
        <>
            <Button
                variant="primary"
                onClick={onStandardClick}
                data-test={NETFLIX_SELECTION_MODAL_TEST_ID.NETFLIX_STANDARD_BUTTON}
            >
                {standardButtonLabel}
            </Button>
            <Button
                variant="secondary"
                onClick={onPremiumClick}
                data-test={NETFLIX_SELECTION_MODAL_TEST_ID.NETFLIX_PREMIUM_BUTTON}
            >
                {premiumButtonLabel}
            </Button>
        </>
    );

    const banner = (
        <img src={`${IMAGES_PATH}/netflix_banner.png`} alt={t['common.netflix_selection_modal.image_alt']} />
    );

    return (
        <Modal open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Modal.Content
                title={title}
                actions={actions}
                stickyButtons={true}
                image={banner}
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                data-test={NETFLIX_SELECTION_MODAL_TEST_ID.MODAL}
                zIndex={NAVIGATION_MODAL_ZINDEX}
            >
                <HtmlContent content={description} />
            </Modal.Content>
        </Modal>
    );
};
